import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";
import "./GestionDigitalizacion.css";

interface GestionItem {
  titulo: string;
  descripcion: string;
}

interface AlcanceItem {
  titulo: string;
  descripcion?: string;
}

interface GestionDigitalizacionProps {
  gestion: GestionItem[];
  alcance: AlcanceItem[];
  tecnologia?: any; // Adjust if technology is used
}

export default function GestionDigitalizacion({
  gestion,
  alcance,
  tecnologia,
}: GestionDigitalizacionProps) {
  const { t } = useTranslation();
  const cajasRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [animadas, setAnimadas] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number((entry.target as HTMLElement).dataset.idx);
            setAnimadas((prev) => {
              if (!prev.includes(idx)) return [...prev, idx];
              return prev;
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 },
    );

    cajasRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [alcance]);

  return (
    <>
      <div className="componente-digitalizacion">
        <h3>{t("gestion.digitalizacion_intro")}</h3>
        <div className="contenedor-digitalizacion">
          {Array.isArray(gestion) && gestion.map((item, idx) => (
            <div className="grupo-digitalizacion1" key={idx}>
              <div className="caja-digitalizacion">{item.titulo}</div>
              <motion.p
                className="descripcion-digitalizacion"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                {item.descripcion}
              </motion.p>
            </div>
          ))}
        </div>
      </div>

      <div className="componente-digitalizacion alcance-fondo">
        <h3>{t("gestion.alcance_title")}</h3>
        <div className="contenedor-digitalizacion2">
          {Array.isArray(alcance) && alcance.map((grupo, idx) => (
            <div className="grupo-digitalizacion2" key={idx}>
              <div
                className="caja-digitalizacion2 con-icono"
                ref={(el) => { cajasRefs.current[idx] = el; }}
                data-idx={idx}
                style={{
                  animation: animadas.includes(idx)
                    ? "bgMove 3s ease-in-out forwards"
                    : "none",
                } as React.CSSProperties}
              >
                <FaCheckCircle className="icono-item" />
                <span className="texto-item">{grupo.titulo}</span>
              </div>
              {grupo.descripcion && (
                <motion.p
                  className="descripcion-digitalizacion2"
                  initial={{ opacity: 0, y: -20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {grupo.descripcion}
                </motion.p>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
